/* eslint-disable no-dupe-keys */
/*
  英语
*/
export default {
  orderList: {
    AllOrder: 'All Orders',
    WaitingPayment: 'Awaiting Payment',
    Pending: 'Waiting To Ship',
    ToBeSighed: 'In Transit',
    Refunding: 'In Refund',
    YouHave: 'You Have',
    orders: 'Orders',
    OrderID: 'Order ID',
    Customer: 'Customer',
    coupon: 'Coupon',
    TotalAmount: 'Total Amount',
    PayNow: 'Pay Now',
    ViewDetails: 'View Details',
    CancelDelivery: 'Cancel Delivery',
    CancelOrder: 'Cancel Order',
    Delete: 'Delete',
    selectContent: 'Select Content',
    startDate: 'Start Date',
    endDate: 'End Date',
    inputPlaceholder: 'Search by Order ID,SKU OR Product Name',
    RequestRefund: 'Request refund',
    ConfirmReceipt: 'Confirm Receipt',
    CancelReason: 'Cancel Reason',
    Verification: 'Verification',
    RefundReason: 'Request Refund',
    Remark: 'Remark',
    cancel: 'Canceled',
    submit: 'Submit',
    ConfirmReceiptTitle: 'Are you sure that you have received the goods and the quality meets the agreement between the parties to the transaction?',
    ConfirmReceiptContent: 'If the confirmation is correct, please click "Confirm" below to complete the confirmation of receipt.',
    removeTheStore: 'Remove the store',
    CancellationReasonIsRequired: 'Cancellation reason is required',
    RefundReasonIsRequired: 'Refund reason is required',
    PleaseSelectThePaymentMethod: 'Please select the payment method',
    Paypal: 'Paypal',
    CreditCard: 'Credit Card',
    Balance: 'Balance',
    SelectByStatus: 'Select By Status',
    SelectByPlatform: 'Select by Platforms',
    FulfillOrder: 'Fulfill Order',
    Store: 'Store',
    StoreOrderID: 'Store Order ID',
    TrackingNumber: 'Tracking number',
    ShippingCarrier: 'Shipping carrier',
    TrackingURL: 'Tracking URL',
    cancelBtn: 'cancel',
    ok: 'ok',
    emptyTips1: 'Your order list is empty!',
    emptyTips2: 'You can manage and process your orders here',
    ChooseProduct: 'Choose Product',
    ChooseProductTips: 'How to Find & List Prodcuts',
    ConnectANewStore: 'Connect a New Store',
    ConnectANewStoreTips: 'How to connect a new store',
    selectAll: 'Select All',
    orderStatusSubTip: 'Please connect our support team'
  },
  orderDetail: {
    PayNow: 'Pay Now',
    ConfirmReceipt: 'Confirm Receipt',
    StoreOrderID: 'Store Order ID',
    OrderID: 'Order ID',
    Source: 'Source',
    IncomeStatement: 'Income Statement',
    CommodityInformation: 'Commodity Information',
    ShipFrom: 'Ship From',
    ItemNo: 'Item No',
    TheDetail: 'The Detail',
    Notes: 'Notes',
    OrderStatus: 'Order Status',
    BalancePayment: 'Balance Payment',
    PaymentTime: 'Payment Time',
    PaymentId: 'Payment ID',
    ItemSubtotal: 'Subtotal',
    ShippingSubtotal: 'Shipping Fee',
    tax: 'Tax',
    PaymentAmount: 'Payment Amount',
    TotalAmount: 'Total Amount',
    ShippingAddress: 'Shipping Address',
    ConfirmReceiptModalTitle: 'Are you sure that you have received the goods and the quality meets the agreement between the parties to the transaction?',
    ConfirmReceiptModalContent: 'If the confirmation is correct, please click "Confirm" below to complete the confirmation of receipt.',
    Cancel: 'Cancel',
    Apply: 'Apply',
    Replace: 'Replace',
    Submit: 'Submit',
    removeTheStore: 'Remove The Store',
    WaitingPayment: 'Awaiting Payment',
    WaitingPaymentTips: 'Your order hasn’t paid yet. Click ”Pay Now” to continue. ',
    OrderCreation: 'Order Submitted',
    Finish: 'Finish',
    PaymentSuccessful: 'Payment Successful',
    IncorrectAddressInformation: 'Incorrect Address Information',
    CancelTips: 'Your order has been cancelled successfully',
    Pending: 'waiting to ship',
    PendingSecondStatus: 'Typically takes less than 72 hours.We’ll let you know once order has shipped',
    PendingTips: 'Every single product goes through our rigorous quality inspection before we send it to your customers.',
    Shipped: 'Shipped',
    Complete: 'Order Complete',
    ShippedTips1: 'You order is on its way !',
    PartialDelivery: 'Partial Shipped',
    ShippedTips2: 'You order is on its way !',
    Refunding: 'Refunding',
    PartialRefund: 'Partial Refund',
    refundedTipsNew: 'The total refund amount for your order is',
    RefundingSecondStatus: 'Your refund will be processed within 1-3 business days',
    RefundingTips: 'Refund request has been submitted. Waiting to be processed',
    Refund: 'Refund',
    Refunded: 'Refunded',
    RefundedSecondStatus: 'Depending on your financial institution, it can take up to 14 days for the funds to show in your accoun',
    RefundedTips: 'Refund request has been accepted. The already paid amount will be refunded to the original payment method',
    CompleteSecondStatus: 'Transaction complete',
    CompleteTips: 'The order has been completed, thank you for your support',
    ShippingMethod: 'Shipping Method',
    MyOrder: 'My Order',
    OrderInformation: 'Order Information',
    ApplyRefund: 'Refund',
    Product: 'Product',
    PurchasePrices: 'Purchase Prices',
    prices: 'Prices',
    Quantity: 'Quantity',
    Subtotal: 'Subtotal',
    Profit: 'Profit',
    ConfirmReceiptTips: 'Pay Attention To The Receipt',
    trackingCode: 'TrackingCode',
    DeliveryTime: 'Shipped time',
    logisticsProviders: 'LogisticsProviders',
    payment: 'payment',
    NotToDeliverGoods: 'Not to deliver goods',
    LogisticsInformation: 'Logistics Information',
    PartialDeliveryTips: 'Some products have not yet shipped，We’ll let you know once it has shipped',
    PaymentInformation: 'Payment Information',
    Balance: 'Balance',
    CreditCard: 'Credit Card',
    payFail: 'Payment failed',
    Remaining: 'Remaining',
    WaitingPaymentWarning: 'Orders not been paid for more than 120 hours will be cancelled',
    OrderCancelled: 'Order cancelled',
    OrderConfirmed: 'Order Confirmed',
    Shipping: 'Shipping',
    OrderComplete: 'Delivered',
    OrderSubmitted: 'Order Submitted',
    promotion: 'Promo code',
    Discount: 'Discount',
    PleaseInput: 'Please Input',
    Note: 'Note',
    EditNote: 'Edit Note',
    Edit: 'Edit',
    EditNoteSuccessTip: 'Note content updated successfully.',
    // NoteTip: 'Here is the content of the note.'
    NoteTip: 'Add A Note to KakaClo.'
  },
  orderRefund: {
    OK: 'OK',
    ALL: 'ALL',
    Refund: 'Refund',
    AllOrder: 'All Orders',
    RefundApplication: 'Refund Application',
    OrderHasBeenRefundedBefore: 'Order has been refunded before',
    RefundRecord: 'Refund Record',
    RefundReason: 'Refund Reason',
    InputContent: 'Input Content',
    Remarks: 'Remarks',
    RefundedAmount: 'Refunded Amount',
    ItemSubtotal: 'Item Subtotal',
    ShippingSubtotal: 'Shipping Subtotal',
    Promotion: 'Promotion',
    Total: 'Total',
    RefundRequestFailed: 'Refund Request Failed',
    ThereIsErrorWithYouRequest: 'There is error with you request',
    PleaseConnectOurSupportTeam: 'Please connect our support team',
    RufundID: 'Rufund ID',
    RufundTime: 'Rufund Time',
    RefundAmount: 'Refund Amount',
    RefundSucceeded: 'Refund Succeeded',
    RefundFailed: 'Refund Failed'
  },
  Order: {
    Sales: {
      Web: {
        Index: {
          RefundingOrder: 'Refunding Order',
          PaymentMethod: 'Payment Method',
          State: 'State',
          StartDate: 'Start Date',
          EndDate: 'End Date',
          SearchingFor: 'searching for',
          Processing: 'Processing',
          Refunding: 'Refunding',
          Rejected: 'Rejected',
          Completed: 'Completed',
          IusseID: 'Iusse ID',
          OrderID: 'Order ID',
          RefundAmount: 'Refund Amount',
          CreationTime: 'Creation Time',
          Type: 'Type',
          NoRecord: 'No Record'
        }
      },
      Details: {
        Web: {
          Index: {
            RefundingOrder: 'Refunding Order',
            RufundOrderDetails: 'Rufund Order Details',
            OrderInformation: 'Order Information',
            ReviewTime: 'Review time',
            ReviewID: 'Review ID',
            RefundRecord: 'Refund Record',
            RufundInformation: 'Rufund Information',
            OrderID: 'Order ID',
            ParcelCode: 'Parcel Code',
            PaymentTime: 'Payment Time',
            NoRecord: 'No Record',
            RefundedAmount: 'Refunded Amount',
            Subtotal: 'Subtotal',
            ShippingFee: 'Shipping Fee',
            PromoCode: 'Promo code',
            Coupon: 'Coupon',
            Total: 'Total',
            ShippingAddress: 'Shipping Address',
            Processing: 'Processing',
            Refunding: 'Refunding',
            Rejected: 'Rejected',
            Completed: 'Completed'
          },
          Components: {
            SkuInfoItemTwo: {
              CustomizedService: 'Customized Service',
              Tips1: 'Flower Decor Asymmetrical Waist Chain',
              StoreSKU: 'Store SKU',
              QTY: 'QTY',
              RefundAmount: 'Refund Amount'
            },
            RefundRecordItem: {
              RufundID: 'Rufund ID',
              RufundTime: 'Rufund Time',
              RefundAmount: 'Refund Amount',
              RefundApplication: 'Refund Application',
              RefundSucceeded: 'Refund Succeeded',
              RefundFailed: 'Refund Failed'
            },
            RefundRecordDialog: {
              NoRecord: 'No Record'
            }
          }
        }
      }
    },
    Refund: {
      Web: {
        Index: {
          MyOrder: 'My order',
          RefundApplication: 'Refund Application',
          RufundOrder: 'Rufund Order',
          OrderHasBeenRefundedBefore: 'Order has been refunded before',
          RefundRecord: 'Refund Record',
          InputContent: 'Input Content',
          PleaseEnterRemarks: 'Please enter Remarks',
          RefundedAmount: 'Refunded Amount',
          Subtotal: 'Subtotal',
          ShippingFee: 'Shipping Fee',
          PromoCode: 'Promo code',
          Coupon: 'Coupon',
          Total: 'Total',
          Refund: 'Refund',
          RefundReason: 'Refund Reason',
          Tips1: 'Please select a refund reason.',
          OutOfStock: 'Out Of Stock',
          ShipmentDelay: 'Shipment Delay',
          DonTWantAnymore: "Don't Want Anymore",
          IncorrectAddressInformation: 'Incorrect Address Information',
          ProductSelectionErrorMultipleSelection: 'Product Selection Error/Multiple Selection',
          Other: 'Other'
        },
        Components: {
          SkuInfoItemOne: {
            CustomizedService: 'Customized Service',
            Tips1: 'Flower Decor Asymmetrical Waist Chain',
            StoreSKU: 'Store SKU',
            Price: 'Price',
            Total: 'Total',
            QTY: 'QTY',
            RefundableAmount: 'Refundable Amount'
          },
          RefundRecordItem: {
            RufundID: 'Rufund ID',
            RufundTime: 'Rufund Time',
            RefundAmount: 'Refund Amount',
            RefundApplication: 'Refund Application',
            RefundSucceeded: 'Refund Succeeded',
            RefundFailed: 'Refund Failed'
          },
          RefundRecordDialog: {
            NoRecord: 'No Record'
          },
          NotShippedGoods: {
            NotShipped: 'Not shipped',
            SelectAll: 'Select All',
            NoRecord: 'No Record'
          }
        }
      },
      Success: {
        Web: {
          Index: {
            MyOrder: 'My order',
            RufundOrder: 'Rufund Order',
            AllOrders: 'All Orders',
            SubmittedSuccessfully: 'Submitted Successfully',
            WaitingForReview: 'Waiting for Review',
            Back: 'Back',
            CheckAfterSales: 'Check After Sales',
            RufundInformation: 'Rufund Information',
            OrderID: 'Order ID',
            TrackingCode: 'Tracking Code',
            PaymentTime: 'Payment Time',
            NoRecord: 'No Record',
            RefundedAmount: 'Refunded Amount',
            ItemSubtotal: 'Item Subtotal',
            ShippingSubtotal: 'Shipping Subtotal',
            Promotion: 'Promotion',
            Total: 'Total',
            ShippingAddress: 'Shipping Address'
          },
          Components: {
            SkuInfoItemTwo: {
              CustomizedService: 'Customized Service',
              Tips1: 'Flower Decor Asymmetrical Waist Chain',
              StoreSKU: 'Store SKU',
              RefundQuantity: 'Refund Quantity',
              RefundAmount: 'Refund Amount'
            }
          }
        },
        Mobile: {
          Index: {
            SubmittedSuccessfully: 'Submitted Successfully',
            WaitingForReview: 'Waiting for Review',
            AllOrders: 'All Orders'
          },
          Components: {
            GoodItem: {
              RefundQuantity: 'Refund Quantity',
              RefundAmount: 'Refund Amount'
            }
          }
        }
      },
      Mobile: {
        Index: {
          Rufund: 'Rufund',
          Tips1: 'Order has been refunded before',
          ViewRefundHistory: 'View refund history',
          NoRecord: 'No Record',
          RefundedAmount: 'Refunded Amount',
          Subtotal: 'Subtotal',
          ShippingFee: 'Shipping Fee',
          PromoCode: 'Promo code',
          Coupon: 'Coupon',
          Total: 'Total',
          Refund: 'Refund',
          OutOfStock: 'Out Of Stock',
          ShipmentDelay: 'Shipment Delay',
          DonTWantAnymore: "Don't Want Anymore",
          IncorrectAddressInformation: 'Incorrect Address Information',
          ProductSelectionErrorMultipleSelection: 'Product Selection Error/Multiple Selection',
          Other: 'Other',
          RefundReason: 'Refund Reason'
        },
        Components: {
          RefundRecord: {
            NoRecord: 'No Record'
          },
          NotShippedGoods: {
            NotShipped: 'Not shipped',
            SelectAll: 'Select All',
            NoRecord: 'No Record'
          },
          GoodItem: {
            Item: 'Item',
            ItemPrice: 'Price',
            Total: 'Total',
            Quantity: 'Quantity',
            RefundableAmount: 'Refundable Amount'
          }
        }
      }
    },
    List: {
      Index: {
        WaitingPayment: 'Waiting Payment',
        WaitingToShip: 'Waiting to Ship',
        InTransit: 'In Transit',
        RefundReturn: 'Refund&Return',
        OrderInfoMissing: 'Abnormal Orders' // 'Order Info Missing'
      },
      Components: {
        TrackingDialog: {
          TrackingNo: 'Tracking No',
          LastCarrier: 'Last Carrier',
          FirstCarrier: 'First Carrier',
          LogisticsTrackingInformation: 'Logistics tracking information',
          TrackingNoFromLastCarrier: 'Tracking No. from Last Carrier',
          TrackingNoFromFirstCarrier: 'Tracking No. from First Carrier',
          PosteItaliane: 'Poste Italiane',
          Tips1: 'Logistics tracking information'
        },
        PayDialog: {
          ShippingAddress: 'Shipping Address',
          Edit: 'Edit',
          OrderAmount: 'Order Amount',
          Subtotal: 'Subtotal',
          ShippingFee: 'Shipping Fee',
          Discount: 'Discount',
          PromoCode: 'Promo Code',
          Total: 'Total',
          Others: 'Others',
          PayNow: 'Pay Now',
          CustomizedService: 'Customized Service',
          DeliveryMethod: 'Delivery Method',
          Warehouses: 'Warehouses',
          LogisticsError: 'Logistics error',
          Tips1: 'Please connect our support team to continue',
          PaymentAmount: 'Payment Amount',
          Tags: 'Tags',
          Package: 'Package',
          Bags: 'Bags',
          SoldOutProduct: 'Out of Stock product',
          ContinueToPay: 'Continue to pay',
          Tips2: 'Please select a coupon',
          OrderConfirmation: 'Order Confirmation',
          OOSTip: 'OOS(out of stock) items are included.Please review the updated order information.',
          ContinueWithoutOOSItems: 'Continue without OOS items',
          OOSItems: 'OOS items',
          AvailableItems: 'Available items'
        },
        OrderStatusTag: {
          WaitingPayment: 'Waiting payment',
          Complete: 'Complete',
          Cancel: 'Cancel',
          WaitingToShip: 'Waiting to Ship',
          FullyShipped: 'Fully Shipped',
          PartialShipped: 'Partial Shipped',
          Refunding: 'Refunding',
          PartialRefund: 'Partial Refund',
          Refunded: 'Refunded',
          AbnormalOrder: 'Abnormal Order'
        },
        MTStatusList: {
          SelectAll: 'Select All',
          Products: 'Products'
        },
        Mobile: {
          AllOrder: 'All Orders',
          WaitingPayment: 'Waiting Payment',
          WaitingToShip: 'Waiting to Ship',
          InTransit: 'In Transit',
          RefundReturn: 'Refund&Return',
          Completed: 'Completed',
          Cancel: 'Cancel',
          OrderInfoMissing: 'Abnormal Orders' // 'Order Info Missing'
        },
        ListTopFilter: {
          PaymentStatus: 'Payment Status',
          WaitingPayment: 'Waiting payment',
          PartialRefund: 'Partial refund',
          Refunding: 'Refunding',
          Refunded: 'Refunded',
          WaitingToShip: 'Waiting to Ship',
          PartialShipped: 'Partial Shipped',
          FullyShipped: 'Fully Shipped',
          Complete: 'Complete',
          Cancel: 'Cancel',
          ExportFailed: 'Export failed',
          ExportAgain: 'Export Again',
          ShipmentStatus: 'Shipment Status',
          ExportOrder: 'Export Order'
        },
        EmptyNoStore: {
          Tips1: 'Sorry, You don’t have any orders'
        },
        EmptyLogistics: {
          Tips1: 'Logistics information has not been updated yet'
        },
        EmptyDataWithParams: {
          Tips1: "Sorry, can't find~   Please search again"
        },
        AllStatus: {
          AutoCheckout: 'Auto Checkout',
          OrdersSelected: 'Orders selected',
          Tips1: 'New Payment orders will automatically checkout using the default',
          Tips2: 'payment method',
          Tips3: 'on file',
          Source: 'Source',
          StoreOrderID: 'Store Order ID',
          Accessories: 'Accessories',
          StoreSKU: 'Store SKU',
          RefundFailed: 'Refund failed',
          AutoCheckoutFailed: 'Auto Checkout Failed',
          PartialRefund: 'Partial Refund',
          Refunded: 'Refunded',
          Products: 'Products',
          CompleteInformation: 'Complete information',
          ExportFailed: 'Export failed',
          ExportAgain: 'Export Again',
          AcceptedCardTypes: 'Accepted card types',
          Tips4: 'To use auto checkout you must have a',
          Tips5: 'payment method on your account.',
          AddACard: 'Add a card',
          ExportOrder: 'Export Order',
          Agree: 'Agree',
          Reject: 'Reject',
          Tips6: 'Do you agree with the shopify buyer to cancel the shipping application?',
          Tips7: 'Agree to cancel the delivery, if you do not need kaka delivery, please apply for a refund in time.',
          Tips8: 'All products are Out of Stock'
        },
        AddressWrongPayDialog: {
          Tips1: 'These Orders are  Missing Required Information',
          OrderID: 'Order ID',
          ContinueToPay: 'Continue to Pay'
        }
      }
    },
    Details: {
      Index: {
        Invoice: 'invoice',
        RefundRecord: 'Refund Record',
        ShippingSoon: 'Shipping Soon',
        Tips1: 'The item is Out of Stock, Please contact customer service',
        ParcelCode: 'Parcel Code',
        LogisticsInformation: 'Logistics Information',
        ConfirmReceipt: 'Confirm Receipt',
        ConfirmReceiptPrompt: 'Have you received all the items in this package?',
        Confirm: 'Confirm',
        Cancel: 'Cancel',
        Completed: 'Completed',
        DeliveryTime: 'Shipped time',
        // TrackingCode: 'Tracking code',
        TrackingCode: 'Tracking number',
        // TailTrackingCode: 'Tail Tracking code',
        TailTrackingCode: 'Last-mile tracking number',
        ShipmentTracking: 'Shipment Tracking',
        LogisticsProviders: 'Logistics providers',
        Accessories: 'Accessories',
        StoreSKU: 'Store SKU',
        Weight: 'Weight',
        Remark: 'Remark',
        CompleteInformation: 'Complete information'
      },
      Components: {
        TraningLineMt: {
          TrackingNo: 'Tracking No',
          LastCarrier: 'Last Carrier',
          ParcelCode: 'Parcel Code',
          FirstCarrier: 'First Carrier'
        },
        TopTimeLine: {
          RefundFailed: 'Refund failed',
          WaitingPayment: 'Waiting payment',
          PayNow: 'Pay Now',
          Tips1: 'Your order hasn’t paid yet. Click ”Pay Now” to continue.',
          OrderSubmitted: 'Order Submitted',
          OrderConfirmed: 'Order Confirmed',
          Shipped: 'Shipped',
          OrderComplete: 'Order Complete',
          Tips2: 'Every single product goes through our rigorous quality inspection before we send it to your customers.',
          WaitingToShip: 'Waiting to Ship',
          PartialShipped: 'Partial Shipped',
          Tips3: 'Some products have not yet shipped，We’ll let you know once it has shipped',
          Shipping: 'Shipping',
          FullyShipped: 'Fully Shipped',
          Tips4: 'You order is on its way !',
          Completed: 'Completed',
          Tips5: 'Your goods are shipped out of the warehouse and are in transit',
          Cancel: 'Cancel',
          Tips6: 'Your order has been cancelled successfully',
          Finish: 'Finish',
          AbnormalOrder: 'Abnormal Order',
          Tips7: 'Incomplete recipient information',
          Tips8: 'Failed to abtain logistics',
          GetLogistics: 'Get Logistics'
        },
        RefundRecordMobile: {
          RufundID: 'Rufund ID',
          RufundTime: 'Rufund Time',
          RefundAmount: 'Refund Amount'
        },
        RefundRecord: {
          RufundID: 'Rufund ID',
          RufundTime: 'Rufund Time',
          RefundAmount: 'Refund Amount',
          RefundRecord: 'Refund Record',
          RefundApplication: 'Refund Application',
          RefundedRefundAmount: 'Refunded Refund Amount',
          RefundFailed: 'Refund Failed'
        },
        MTDetail: {
          OrderInformation: 'Order information',
          ShippingSoon: 'Shipping Soon',
          LogisticsInformation: 'Logistics Information',
          ParcelCode: 'Parcel Code',
          TrackYourShipment: 'Track your shipment',
          ConfirmReceipt: 'Confirm Receipt',
          OrderID: 'Order ID',
          StoreOrderID: 'Store Order ID',
          Source: 'Source',
          Store: 'Store',
          ShippingMethod: 'Shipping Method',
          PaymentInformatio: 'Payment Informatio',
          PaymentTime: 'Payment Time',
          PaymentMethod: 'Payment Method',
          Subtotal: 'Subtotal',
          Delivery: 'Shipping Fee',
          Promotion: 'Promotion',
          Total: 'Total Amount',
          Invoice: 'invoice',
          PayNow: 'pay now',
          Refunding: 'Refunding',
          PartialRefund: 'Partial Refund',
          Refunded: 'Refunded',
          PaymentAmount: 'Payment Amount'
        },
        CancelMT: {
          Submit: 'Submit'
        }
      }
    },
    Custom: {
      Web: {
        Index: {
          CustomOrders: 'Custom Orders',
          NoRecord: 'No Record',
          Export: 'Export'
        }
      }
    }
  },
  Dropshipping: {
    Module1: {
      Title1: 'Learn about KakaClo dropshipping',
      Title2: 'Apparel ',
      Title3: ' Dropshipping',
      Title4: 'Has Never Been So Easy',
      Sub1: '· Find the best dropshipping products from verified suppliers',
      Sub2: '· Completely Free',
      Sub3: '· Suitable shopify & tiktok dropshipping for beginners',
      StartSelling: 'Start Selling',
      SignUpForFree: 'Sign Up For Free'
    },
    Module2: {
      Title1: 'KakaClo Quality Control Center Provides',
      Title2: 'Customers With ',
      Title3: 'The Best Quality',
      Title4: 'Why Choose KakaClo To Dropship Clothes',
      Sub1: 'KakaClo applies strict quality inspection to every single piece before shipping them out, thus you can rest assured with your customer satisfaction regarding the quality of products.',
      Sub2: 'KakaClo, the industry-leading apparel supply chain platform, provides Dropshipping Service for products available in stock in European and American warehouses.',
      CaptionTitle1: 'Packed Discreetly',
      CaptionTitle2: 'Provide Sample',
      CaptionTitle3: 'Original Design',
      CaptionTitle4: 'Raw Materials and Processes',
      CaptionTitle5: 'Perfect After-sales',
      CaptionTitleAdditiona1: '(Can be customized as needed)',
      CaptionTitleAdditiona2: '(Can apply for sample clothes)',
      CaptionTitleAdditiona3: '(Own Factory and designer)',
      CaptionTitleAdditiona4: '(Original factory controls raw materials and processes)',
      SelectReasonTitle1: 'Professional R&D team and Its own apparel factory',
      SelectReasonTitle2: 'Independent quality inspection center',
      SelectReasonTitle3: 'Global logistics and warehousing system',
      SelectReasonTitle4: 'User friendly integration solutions',
      SelectReasonTitleAdditiona1: 'KakaClo provides the customers with latest unique on-trend items with super competitive prices',
      SelectReasonTitleAdditiona2: 'Unlike other dropshipping suppliers, KakaClo does strict quality inspection itself before every single piece being shipped out',
      SelectReasonTitleAdditiona3: 'Ensures fast and effective order processing and delivery and now has warehouses in Europe America and China',
      SelectReasonTitleAdditiona4: 'KakaClo users can easily add their own stores to KakaClo platform and upload products with only a few clicks',
      advantageTitle1: 'Sell With Ease',
      advantageTitle2: 'Up to Date Inventory',
      advantageTitle3: 'Best Quality Products',
      advantageTitle4: 'Great Profit Margin',
      advantageTitle5: 'Super Fast Delivery',
      Questions1: 'How Does KakaClo Ensure The Quality of Dropshipping products?',
      LinkUrl1: 'Learn about KakaClo dropshipping'
    },
    Module3: {
      Title1: 'How Does Dropshipping Work On KakaClo',
      Title2: 'Listing Product',
      Title3: 'Receiving Order',
      Title4: 'Checking Quality',
      Title5: 'Fulfiling Package',
      Sub1: 'Upload products from KakaClo to Shopify and TikTok store with one click',
      Sub2: 'Your customer places an order on your online store',
      Sub3: 'Strict quality inspection before every single piece being shipped out',
      Sub4: 'Real-time traceable delivery fulfilled by KakaClo',
      StartNow: 'Start Now'
    },

    Module4: {
      Title1: 'Must-Read Guide For Clothing Dropshipping'
    },
    Module5: {
      Title1: 'The Latest Additions To The Dropshipping Product Lineup',
      Sub1: 'Women’s Apparel',
      Sub2: 'Men’s Apparel',
      Sub3: 'Accessories'
    },
    Module7: {
      Title1: 'Start Selling for Free',
      Sub1: 'Grow Your Fashion Business with KakaClo',
      StartSelling: 'Start Selling'
    },
    Module8: {
      Title1: 'Tips For First Encounter With Dropshipping',
      Questions1: 'Is clothing good for dropshipping?',
      Questions2: 'How to Choose the Best Dropshipping Suppliers?',
      Questions3: 'Is KakaClo dropshipping suitable for boutiques/stores?',
      Questions4: 'Is there a long-term contract for KakaClo dropshipping?',
      Questions5: 'Can you customize packaging for me?',
      Questions6: 'Is there a minimum order quantity for each product?',
      Questions7: 'How to process a dropshipping order?',
      Questions8: 'Do you provide POD(Print-On-Demand)dropshipping services?',
      Answer1: 'Yes, clothing is one of the suitable products for dropshipping. Dropshipping is a retail model where you can sell clothing without holding inventory, and you fulfill orders directly from suppliers once they are placed. This makes operations more flexible, but the key to success lies in choosing reliable suppliers and identifying an appealing target market.',
      Answer2: '<p>The selection of clothing dropshipping suppliers involves various considerations such as price, after-sales service, source of goods, and more. The following factors can be taken into consideration.</p><ul><li>How do they handle returns or damaged products?</li><li>How long does it take them to fulfill an order, from sale to delivery?</li><li>How is their customer support? (Feel free to test this yourself.)</li><li>Do they insure orders?</li><li>Do they offer fraud protection?</li><li>Can you find reviews or references online?</li></ul>',
      Answer3: 'Yes! Numerous brick-and-mortar stores utilize KakaClo to establish an online presence without having to list their in-store inventory on a website.',
      Answer4: 'Nope.',
      Answer5: 'Certainly! We can provide thank you cards, hang tags, custom printed/designed boxes, or bags – whatever you need.',
      Answer6: 'Nope',
      Answer7: '<p>As you create a KakaClo account, you can start dropshipping on KakaClo.</p><p>Let\'s say Timothy is a customer of Your Store.</p><ol><li>1.Timothy finds a product he likes and buys it from your store.</li><li>2.Timothy\'s order is automatically placed with us, we fulfill the order and send it to Timothy, and we charge for fulfillment as soon as the order is confirmed.</li></ol><p>If Timothy buys a T-shirt for $20 in your store. KakaClo\'s price for the product and fulfillment are $8 totally. So from the $20 Timothy paid for the T-shirt, you get a $12 profit.</p><p>That\'s how KakaClo dropshipping works for its users.</p>',
      Answer8: 'We provide POD(Print-On-Demand) services, including various unique products such as T-shirts, hoodies, shoes, bags, socks, hats, and more.'

    }
  }
}
